import { Component, Input, OnInit } from '@angular/core';
import { BaseAppMComponent } from '../../base-components/base-app-m.component';
import { GlobalsService } from '../../services/globals.service';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';

import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DQOIReferenceData } from '../../models/DQOIReferenceData';
import { BaseDQOIComponent } from '../../base-components/base-dqoi.component';
import { AppClaims } from '../../models/AppClaims';
import { InventoryService } from '../../services/inventory.service';
import { CRUDActions } from '../../enums/CRUDActions';
import { InventorySubcategoryBus } from '../../models/InventorySubcategoryBus';
import { CommonFunctions } from '../../static/common-functions';
import { InventoryCategoryBus } from '../../models/InventoryCategoryBus';
import { BaseMessageInfo } from '../../models/BaseMessageInfo';
import { CommonValues } from '../../static/CommonValues';
import { ConfirmOutput } from '../../models/ConfirmOutput';
import { CPDialogResult } from '../../enums/CPDialogResult';

@Component({
    selector: 'part-subcategory-dialog',
    templateUrl: './part-subcategory-dialog.component.html',
    styleUrls: ['./part-subcategory-dialog.component.scss']
})
export class PartSubcategoryDialogComponent extends BaseAppMComponent<InventorySubcategoryBus, InventoryService, null, null> implements OnInit {

    appCode: string = null;
    constructor(
        globals: GlobalsService,
        featureFlagService: FeatureFlagService,
        public svc_data: InventoryService,
        qry_rd: DQOIReferenceDataQuery,

    ) {
        super(globals, featureFlagService, qry_rd);

        this.appCode = "Part Sub Category";
    }

    public editForm: UntypedFormGroup;

    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }

    saving: boolean = false;
    active: boolean = false;
    data: any;

    isSubcategorySelected: boolean = false;
    isNewSubcategory: boolean = false;
    isSaveReady: boolean = false;
    inventorySubcategoryData: InventorySubcategoryBus[] = [];
    inventoryCategoryData: InventoryCategoryBus[] = [];
    selectedSubcategoryData: InventorySubcategoryBus;
    action1: CRUDActions;

    @Input() title: string;
    @Input() message: string;

    public show(id?: any) {
        this.createForm();
        this.active = true;
        this.isSubcategorySelected = false;
        this.isNewSubcategory = false;
        this.isSaveReady = false;

        this.svc_data.getInventorySubcategories().subscribe(data => {
            this.inventorySubcategoryData = data.resultList;
        });

    }

    createForm() {
        this.editForm = new UntypedFormGroup({
            'inventorySubCategoryId': new UntypedFormControl(),
            'inventorySubCategoryName': new UntypedFormControl(),
            'subcategory': new UntypedFormControl(),
            'isActive': new UntypedFormControl(),
        });
    }

    public inventorySubcategorySelected(selectedValue: any): void {
        if (selectedValue) {
            let dataObject: InventorySubcategoryBus = this.inventorySubcategoryData.find(x => x.inventorySubCategoryId === selectedValue.inventorySubCategoryId);
            this.setSubcategoryFormData(dataObject);
            this.isSubcategorySelected = true;
            this.isNewSubcategory = true;
        }
        else {
            this.clear();
            this.isSubcategorySelected = false;
            this.isNewSubcategory = false;
        }
    }

    public setSubcategoryFormData(formData: InventorySubcategoryBus) {
        if (CommonFunctions.hasValue(formData)) {
            this.editForm.patchValue({
                inventorySubCategoryId: formData.inventorySubCategoryId,
                inventorySubCategoryName: formData.inventorySubCategoryName,
                isActive: formData.isActive,
            });
        }
        else {
            console.log("No data to map");
        }
    }

    ok() {
        this.trySave();
    }

    new() {
        this.isSubcategorySelected = true;
        this.isNewSubcategory = true;
        this.isSaveReady = true;
        this.editForm.patchValue({
            isActive: true,
        });
    }

    trySave() {
        let inventorySubcategoryId = this.editForm.value.inventorySubCategoryId;
            let inventorySubcategoryName: any = this.editForm.value.inventorySubCategoryName;
            let isCategoryActive = this.editForm.get("isActive").value;
        let doesInventorySubcategoryExist: any = this.inventorySubcategoryData.find(s => s.inventorySubCategoryName === inventorySubcategoryName && inventorySubcategoryId != s.inventorySubCategoryId);
        if (doesInventorySubcategoryExist) {
                this.cnfShow("The Inventory Sub Category already exists.", CRUDActions.None, null, "Duplicate Inventory Sub Category", "DUP_inventoryCategoryName", false);

            }
            else {
                this.save();
            }
        }

    confirmCustom(data: ConfirmOutput) {
        if (data.dialogResult === CPDialogResult.ok && data.code === "EDIT_EXISTING") {
            this.save();
        }
    }

    save() {
        let user = this.globals.user;
        let inventorySubcategoryName: any = this.editForm.value.inventorySubCategoryName;
        let busObj: InventorySubcategoryBus = new InventorySubcategoryBus();

        busObj.setFromForm(this.editForm.value);
        busObj.companyId = this.globals.companyId;
        busObj.setCommon(user.userid, new Date(Date.now()));
        busObj.setBeforeSave();

        if (!busObj.inventorySubCategoryId) { busObj.inventorySubCategoryId = CommonValues.Guid_Empty }

        this.svc_data.saveInventorySubcategory(busObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.saveSuccess();
                this.svc_data.getInventorySubcategories().subscribe(data => {
                    this.inventorySubcategoryData = data.resultList;
                });

                this.clear();
                this.isSubcategorySelected = false;
                this.isSaveReady = false;
                this.isNewSubcategory = false;
            }
            else {
                this.saveError(info.message);
            }

        },
            err => { this.CallFailed(err) }
        );
    }

    CallFailed(err) {
        this.saveError(err)
    }

    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action1 = CRUDActions.None;
    }

    cancel() {
        if (this.isSubcategorySelected) {

            this.clear();
            this.isSubcategorySelected = false;
            this.isSaveReady = false;
            this.isNewSubcategory = false;
        } else {
            this.hide();
        }
    }

    close() {
        this.hide();
    }
}
